import { imgMainBackground } from "../../../shared/assets/img/index";

const searchVariants = ["Брокер", "Фин. советник", "IT", "Начало карьеры", "Маркетолог", "Банк", "Аналитика"];

const title = <>БКС&nbsp;&mdash;&nbsp;вселенная инвестиций и&nbsp;карьерных возможностей</>;

const mobileTitle = {
    first: "БКС — вселенная инвестиций",
    second: "и карьерных возможностей",
};

const imageAttributes = { src: imgMainBackground };

export { searchVariants, title, imageAttributes, mobileTitle };
